<template>
  <div>
    <!-- <v-toolbar-side-icon
      class="hidden-sm-and-up"
      @click.stop="sideNav = !sideNav"
      color="white"
    ></v-toolbar-side-icon> -->
    <!-- <v-navigation-drawer permanent enable-resize-watcher v-if="sideNav"> -->
    <v-navigation-drawer permanent>
      <slot></slot>
      <v-list>
        <v-list-tile
          :class="activeMenu == 6 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 6)"
        >
          <v-list-tile-title>Funding Details</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 1 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 1)"
        >
          <v-list-tile-title>Basic Information</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 12 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 12)"
        >
          <v-list-tile-title>Porichoy NID Data</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 2 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 2)"
        >
          <v-list-tile-title>Professional Information</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 3 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 3)"
        >
          <v-list-tile-title>Documents</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 4 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 4)"
        >
          <v-list-tile-title>Bank Details</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 9 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 9)"
        >
          <v-list-tile-title>Bank Statement Data</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 5 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 5)"
        >
          <v-list-tile-title>Other Contact Information</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-if="status > 7 && status != 10"
          :class="activeMenu == 7 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 7)"
        >
          <v-list-tile-title>EMIs</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          :class="activeMenu == 8 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 8)"
        >
          <v-list-tile-title>Credit Score</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          :class="activeMenu == 13 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 13)"
        >
          <v-list-tile-title>Loan History</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          :class="activeMenu == 10 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 10)"
        >
          <v-list-tile-title>Downloads</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-if="status < 8"
          :class="activeMenu == 11 ? 'active' : 'pointer'"
          @click="$emit('changeMenu', 11)"
        >
          <v-list-tile-title>Actions</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
  export default {
    props: ["activeMenu", "status"],
    // data() {
    //   return {
    //     sideNav: window.innerHeight < 600 ? false : true,
    //   };
    // },
  };
</script>
<style scoped>
  .active {
    color: #3f51b5;
  }
  .pointer {
    cursor: pointer;
  }
</style>
